export default {
      id: "oc-bill-set-cny-usage",
      viewBox: "0 0 200 200",
      url: __webpack_public_path__ + "sprite.svg#oc-bill-set-cny",
      toString: function () {
        return this.url;
      }
    }